/**
 * Created by lihanying on 2017/8/6.
 */
import React from 'react'
import { Modal, Table, Button } from 'antd'
import { clickDownload, round } from '../../../util/index'
import { changeToDecimal } from '../../../util'
export default class extends React.Component {
  render() {
    const { visible, list } = this.props
    const columns = [
      {
        title: '排序',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '商品名称',
        dataIndex: 'commodity_name',
        key: 'commodity_name',
      },
      {
        title: '时间',
        dataIndex: 'ctime',
        key: 'ctime',
      },
      {
        title: '操作人员',
        dataIndex: 'operating',
        key: 'operating',
      },
      {
        title: '购入数量',
        dataIndex: 'qty_income',
        key: 'qty_income',
      },
      {
        title: '支出数量',
        dataIndex: 'qty_outcome',
        key: 'qty_outcome',
      },
      {
        title: '成本价格',
        dataIndex: 'cost_incomes',
        key: 'cost_incomes',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
    ]

    const data = list.map((item) => {
      item.cost_incomes = round(item.cost_income / 100, 2)
      return item
    })

    return (
      <div>
        <Modal
          title="操作记录"
          visible={visible}
          onOk={this.props.handleOk}
          onCancel={this.props.handleCancel}
          width="1000px"
        >
          <div className="profession">
            <Table
              rowKey="id"
              bordered
              columns={columns}
              dataSource={data}
              size="middle"
            />
            {data.length > 0 && (
              <div className="profession-edit-btn">
                <Button
                  style={{ marginLeft: '1rem', backgroundColor: '#1AAD19' }}
                >
                  <a
                    id="test"
                    href={clickDownload(columns, data)}
                    download="downlaod.csv"
                    style={{ color: 'white' }}
                  >
                    导出报表
                  </a>
                </Button>
              </div>
            )}
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubRepertory/component/modalDetail.js